import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false,
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filters: {}, diffs: {}): any[] {
    if (!items) {
      return [];
    }
    if (!filters) {
      filters = {};
    }
    if (!diffs) {
      diffs = {};
    }
    // filter items array, items which match and return true will be kept, false will be filtered out
    const res = items.filter((item: any) => {
      let state = true;
      Object.keys(filters).forEach((d) => {
        state = state && item[d] === filters[d];
      });
      Object.keys(diffs).forEach((d) => {
        state = state && item[d] !== diffs[d];
      });
      return state;
    });
    return res;
  }
}
